import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';

declare function gtag(...args: unknown[]): void;

@Injectable({
    providedIn: 'root',
})
export class GoogleAnalyticsService {
    private initialized = false;

    // Path words that should render fully uppercase rather than title-cased (e.g. `csp` -> `CSP`).
    private static readonly ACRONYMS = new Set(['csp']);

    constructor(private router: Router) {}

    private titleCaseWord(word: string): string {
        if (GoogleAnalyticsService.ACRONYMS.has(word.toLowerCase())) return word.toUpperCase();
        return word.replace(/\b\w/g, c => c.toUpperCase());
    }

    private titleFromPath(path: string): string {
        const clean = path
            .split('?')[0]
            .split('#')[0]
            .replace(/^\/+|\/+$/g, '');
        if (!clean) return 'Home';
        return clean
            .split('/')
            .map(seg =>
                seg
                    .replace(/[-_]/g, ' ')
                    .split(' ')
                    .map(word => this.titleCaseWord(word))
                    .join(' '),
            )
            .join(' - ');
    }

    init(): void {
        if (this.initialized) return;
        if (!environment.production || !environment.gaMeasurementId) return;
        this.initialized = true;

        this.router.events.pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd)).subscribe(event => {
            if (typeof gtag === 'function') {
                const path = event.urlAfterRedirects;
                const title = this.titleFromPath(path);
                document.title = title;
                gtag('event', 'page_view', {
                    page_title: title,
                    page_location: window.location.origin + path,
                    page_path: path,
                });
            }
        });
    }
}
